import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  List,
  Image,
} from "antd";
import {
  baseUrl,
  GET_LAWSUIT_DETAIL_BY_ID,
  GET_LOAN_BY_CONTNO,
  HEADERS_EXPORT,
} from "../../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import { PARAM_PUBLIC } from "../../../../utils/constant/StatusConstant";
import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import CheckGovermentOfficer from "../../../../hook/CeckGovermentOfficer";
import EditAseestSuccess from "../../investigateAssets/modal/EditAseestSuccess";

const AssetsSummary = ({
  open,
  close,
  dataDefualt,
  funcUpdateStatus,
  investigate,
}) => {
  const [form] = Form.useForm();
  const [setupGovernmentOfficerList, governmentOfficers] =
    CheckGovermentOfficer();
  const [currencyFormatComma] = CurrencyFormat();
  const [convertDateThai] = DateCustom();
  const { TextArea } = Input;
  const [isModal, setIsModal] = useState(false);
  const [loading, setLoading] = useState();
  const [dataLoadLoan, setDataLoadLoan] = useState(null);
  const [arrow, setArrow] = useState("Show");
  const [dataLoadLawSuit, setDataLoadLawSuit] = useState(null);
  const [dataPropertyList, setDataPropertyList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [isModalEditAssetsDetail, setIsModalEditAssetsDetail] = useState(false);
  const [dataEdit, setDataEdit] = useState();

  useEffect(() => {
    console.log("dataDefualt", dataDefualt);
    if (dataDefualt.investigation_status !== 1) {
      loadImages();
    } else {
      loadData();

      setDataPropertyList(dataDefualt.property_list);
    }
  }, []);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, []);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
    setIsModal(false);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      await axios
        .get(baseUrl + GET_LOAN_BY_CONTNO + dataDefualt.CONTNO, {
          headers: HEADERS_EXPORT,
        })
        .then(async (resQuery) => {
          if (resQuery.status === 200) {
            setDataLoadLoan(resQuery.data);
            setupGovernmentOfficerList(resQuery.data);
            console.log("loanRes", resQuery.data);
          } else {
            message.error("ไม่พบข้อมูล");
          }
        })
        .catch((err) => console.log("ไม่มีข้อมูล", err));

      await axios
        .get(baseUrl + GET_LAWSUIT_DETAIL_BY_ID + dataDefualt.LAWSUIT_ID, {
          headers: HEADERS_EXPORT,
        })
        .then(async (resQuery) => {
          if (resQuery.status === 200) {
            console.log("resQuery--->", resQuery.data);
            setDataLoadLawSuit(resQuery.data);
          } else {
            message.error("ไม่พบข้อมูล");
          }
        })
        .catch((err) => console.log("ไม่มีข้อมูล", err));
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const loadImages = async () => {
    let urlReq;
    if (dayjs(dataDefualt.investigation_date) < dayjs("2025-09-10")) {
      urlReq = `${baseUrl}/files/lawyer/investigate-property/${PARAM_PUBLIC}/${dataDefualt?.CONTNO}`;
    } else {
      console.log("2");
      urlReq = `${baseUrl}/files/lawyer/investigate-property/${PARAM_PUBLIC}/${
        dataDefualt?.CONTNO
      }_${dayjs(dataDefualt.investigation_date).format("YYYY-MM-DD")}_${
        dataDefualt?.commission
      }`;
    }
    await axios
      .get(urlReq)
      .then((response) => {
        console.log("ImageList", response.data);
        setImageList(response.data);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครับ");
  };

  const onChangeInputMemo = (value) => {
    console.log(value);
  };

  const handleEdit = (item, index) => {
    console.log("item0", item, index);
    setDataEdit(dataPropertyList[index]);
    setIsModalEditAssetsDetail(true);
  };

  const sortedData = dataPropertyList.sort(
    (a, b) => a.investigation_type_id - b.investigation_type_id
  );

  const listItem = (item, index) => {
    return (
      <List.Item>
        <List.Item.Meta
          title={
            <Link onClick={() => handleEdit(item, index)}>
              {item.possessor} <br /> สืบเมื่อ{" "}
              {convertDateThai(item.investigation_date)}
            </Link>
          }
          description={
            <>
              <p
                style={{
                  color: item.estimated_price ? "blue" : "red",
                }}
              >
                {item.estimated_price
                  ? `ยอดประเมินที่ดิน ${currencyFormatComma(
                      item.estimated_price
                    )}  บาท `
                  : "ยังไม่ประเมินจากคุณหนุ่ม"}
              </p>
              <p
                style={{
                  color: item.estimated_enforce_price ? "green" : "red",
                }}
              >
                {item.estimated_enforce_price
                  ? `ยอดประเมินจาก(จพค.) ${currencyFormatComma(
                      item.estimated_enforce_price
                    )}  บาท `
                  : "กรุณาอัพเดทราคาประเมินจากกรมบังคับคดี"}
              </p>

              <p>{`เลขโฉนด ${item.deed_number} อำเภอ ${item.district_desc} จังหวัด${item.province_desc}`}</p>

              <p>หมายเหตุ {item.mark}</p>
              <p
                style={{
                  color: item.mortgagee ? "red" : "lightgreen",
                }}
              >
                {item.mortgagee
                  ? `เจ้าหนี้${item.mortgage_type} ${item.mortgagee} จำนวน ${
                      item.mortgage_balance
                        ? currencyFormatComma(item.mortgage_balance)
                        : "-"
                    } บาท`
                  : null}
              </p>
              <p
                style={{
                  color: item.sequestrate_status ? "red" : "lightgreen",
                }}
              >
                {item.sequestrate_status
                  ? `ติดอายัดกับ ${item.preference_creditor}`
                  : null}
              </p>
              <p
                style={{
                  color:
                    item.estimated_enforce_price > item.mortgage_balance
                      ? "green"
                      : "red",
                }}
              >
                {item.sequestrate_status && item.mortgage_balance
                  ? item.estimated_enforce_price
                    ? item.estimated_enforce_price > item.mortgage_balance
                      ? "พอเฉลี่ย"
                      : "ไม่พอเฉลี่ย"
                    : null
                  : null}
              </p>
            </>
          }
        />
        <p
          style={{
            color:
              item.seize_status === 1 || item.seize_status === 4
                ? "blue"
                : item.seize_status === 3
                ? "green"
                : "red",
          }}
        >
          {" "}
          {item.seize_status === 0
            ? "ยึดแล้ว"
            : item.seize_status === 1
            ? "ตั้งเรื่องยึด"
            : item.seize_status === 3
            ? "ยึดสำเร็จ"
            : item.seize_status === 4
            ? "ตั้งเรื่องยึด"
            : "ยังไม่ยึด"}
        </p>
      </List.Item>
    );
  };

  const checkEstimatePrice = () => {
    const checkData = dataPropertyList.map((item) => !item.estimated_price); // ได้ array ของ true, false
    // ถ้าทุกค่าภายใน checkData เป็น false (หมายความว่า ประเมินหมดแล้ว)
    const allFalse = checkData.every((value) => value === false);
    console.log("allFalse--->", allFalse);
    return allFalse
      ? // <Button style={{ color: "green" }} htmlType="submit">
        //   ส่งบังคับคดี
        // </Button>
        null
      : null;
  };

  const formDataSet = () => {
    return (
      <Form
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 14,
        }}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          suspensionAmount: 0,
          investigateAssetsDate: dayjs(),
          memo: dataDefualt.mark,
        }}
      >
        <Form.Item label="เลขสัญญา/เจ้าของสัญญา" name="ownerSign">
          <p>
            {`${dataDefualt?.CONTNO}/${dataDefualt?.CUSTOMER_TNAME}
            ${dataDefualt?.CUSTOMER_FNAME} ${dataDefualt?.CUSTOMER_LNAME}`}
          </p>
        </Form.Item>
        <Form.Item label="วันที่บันทึก" name="investigateAssetsDate">
          <p>{convertDateThai(dataDefualt.investigation_date)}</p>
        </Form.Item>

        {dataDefualt.investigation_status !== 1 ? (
          <>
            <Form.Item label="สถานะ" name="investigateAssetsDate">
              <p>
                {dataDefualt.investigation_status === 0
                  ? "ไม่เจอทรัพย์"
                  : dataDefualt.investigation_status === 2
                  ? "อายัดเงินได้"
                  : null}
              </p>
            </Form.Item>
            <Form.Item label="ไฟล์" name="file">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px", // เพิ่มช่องว่างระหว่างแต่ละไฟล์
                  justifyContent: "center", // จัดให้อยู่ตรงกลาง
                }}
              >
                <Image.PreviewGroup>
                  {imageList?.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "8px", // ระยะห่างระหว่างไอคอนกับลิงก์
                        textAlign: "center",
                      }}
                    >
                      {image.url.includes("pdf") ? (
                        <>
                          <a
                            href={image.url}
                            download
                            style={{ display: "inline-block" }}
                          >
                            <FilePdfOutlined
                              style={{ fontSize: "40px", color: "red" }}
                            />
                          </a>
                          {image.url ? (
                            <a
                              style={{
                                display: "block",
                                marginTop: "8px",
                              }}
                              href={image.url || "#"}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              คลิกเพื่อดาวน์โหลด
                            </a>
                          ) : null}
                        </>
                      ) : image.url.includes(".xlsx") ? (
                        <>
                          <a
                            href={image.url}
                            download
                            style={{ display: "inline-block" }}
                          >
                            <FileExcelOutlined
                              style={{ fontSize: "40px", color: "green" }}
                            />
                          </a>
                          {image.url ? (
                            <a
                              style={{
                                display: "block",
                                marginTop: "8px",
                              }}
                              href={image.url || "#"}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              คลิกเพื่อดาวน์โหลด
                            </a>
                          ) : null}
                        </>
                      ) : image.url.includes(".docx") ? (
                        <>
                          <a
                            href={image.url}
                            download
                            style={{ display: "inline-block" }}
                          >
                            <FileWordOutlined
                              style={{ fontSize: "40px", color: "blue" }}
                            />
                          </a>
                          {image.url ? (
                            <a
                              style={{
                                display: "block",
                                marginTop: "8px",
                              }}
                              href={image.url || "#"}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              คลิกเพื่อดาวน์โหลด
                            </a>
                          ) : null}
                        </>
                      ) : (
                        <Image
                          src={image.url}
                          alt={`Captured ${index}`}
                          width="150px"
                        />
                      )}
                    </div>
                  ))}
                </Image.PreviewGroup>
              </div>
            </Form.Item>
          </>
        ) : (
          <Form.Item
            label="ทรัพย์ที่สืบเจอ"
            name="assetsFound"
            labelCol={{ span: 6 }} // กำหนดความกว้างของ label
            wrapperCol={{ span: 16 }} // กำหนดความกว้างของ input หรือ content
          >
            <List
              itemLayout="horizontal"
              dataSource={sortedData}
              renderItem={(item, index) => listItem(item, index)}
            />
          </Form.Item>
        )}

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={5}
            onChange={(e) => onChangeInputMemo(e.target.value)}
          />
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button
            onClick={handleCancel}
            style={{ color: "red", marginRight: "20px" }}
          >
            ปิด
          </Button>

          {/* {checkEstimatePrice()} */}
        </div>
      </Form>
    );
  };

  return (
    <>
      <Modal
        title={`ประเมินทรัพย์`}
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Card>{formDataSet()}</Card>
        </Spin>
        {isModalEditAssetsDetail ? (
          <EditAseestSuccess
            open={isModalEditAssetsDetail}
            close={setIsModalEditAssetsDetail}
            dataLoan={dataLoadLoan}
            dataDefualt={dataDefualt}
            governmentOfficers={governmentOfficers}
            handleEdit={null}
            dataIndex={dataEdit}
          />
        ) : null}
      </Modal>
    </>
  );
};
export default AssetsSummary;
